import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-product-analytics',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    {
      provide: TabComponent,
      useExisting: ProductAnalyticsComponent,
    },
  ],
  templateUrl: './product-analytics.component.html',
  styleUrl: './product-analytics.component.scss',
})
export class ProductAnalyticsComponent extends TabComponent {
  override name: string = this.dictionaryService.get('ProductAnalytics');

  public async main(): Promise<void> {}
}
